<!--

This component is a key-value that takes up all available space, and is repsonive

-->

<template>
  <div class="row mb-5">

    <div class="col-12 text-bold text-primary font-size-125">
      {{title}}
    </div>

    <div class="col-12 mt-3">
      <slot>
      </slot>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: ['title']
}
</script>

<style>
</style>
